module.exports = __webpack_public_path__ + "static/media/mastercard.4f14ddb6.webp";